const STORAGE_KEY = "fiinder_recently_visited";
const MAX_ITEMS = 10;

/** Event name dispatched on window after a recent page is added. */
export const RECENT_PAGES_CHANGED_EVENT = "fiinder:recent-pages-changed";

export type RecentPage = {
  title: string;
  description?: string;
  url: string;
  fetchUrl?: string;
  keywords?: string[];
  og_image?: string;
  visitedAt: string;
};

export function getRecentPages(limit?: number): RecentPage[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    if (!Array.isArray(parsed)) return [];
    const validItems = parsed.filter(
      (item): item is RecentPage =>
        item &&
        typeof item.title === "string" &&
        typeof item.url === "string" &&
        typeof item.visitedAt === "string"
    );
    return limit ? validItems.slice(0, limit) : validItems.slice(0, MAX_ITEMS);
  } catch {
    return [];
  }
}

export function addRecentPage(page: Omit<RecentPage, "visitedAt">): void {
  try {
    const current = getRecentPages();
    const updated = [
      { ...page, visitedAt: new Date().toISOString() },
      ...current.filter((item) => item.url !== page.url),
    ].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    window.dispatchEvent(new CustomEvent(RECENT_PAGES_CHANGED_EVENT));
  } catch {
    // Silently fail if quota exceeded or localStorage unavailable
  }
}

export function clearRecentPages(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Silently fail
  }
}
